var clone = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};

export { clone as default };
//# sourceMappingURL=clone.js.map
